import axios from 'axios';
import { decrypt, encrypt } from './AESUtil'; // 假设你有一个用于获取配置信息的 API 函数
import { get, post } from './request2';

// 请求地址
let API_BASE_URL = '';

/*let env = process.env.UMI_ENV;
if (env === 'local') {
  API_BASE_URL = 'http://127.0.0.1:8290';
} else if (env === 'development') {
  API_BASE_URL = 'https://test.connectnowai.com';
} else if (env === 'production') {
  API_BASE_URL = 'https://www.connectnowai.com';
}*/
API_BASE_URL = 'https://' + process.env.API_HOST;
// 更新 Token
export const updateToken = async () => {
  const params = {
    client_id: process.env.CLIENT_ID,
    client_secret: process.env.SECURITY_KEY,
  };
  const response = await axios.post(API_BASE_URL + '/api/openapi/oauth/token', params);
  if (response?.data?.code === 200) {
    const tokenData = response.data.data;
    localStorage.setItem('connectNow', JSON.stringify(tokenData));
    localStorage.setItem('connectNowToken', JSON.stringify(`Bearer ${tokenData.access_token}`));
    return `Bearer ${tokenData.access_token}`;
  } else {
    throw new Error('Failed to fetch token');
  }
};
//获取人工工作时间
export const checkWorkTime = async (params, header) => {
  let token = JSON.parse(localStorage.getItem('connectNowToken'));
  const responseData = await post(API_BASE_URL + '/api/openapi/ticketController/workTimeInspection', params, {
    ...header,
    Authorization: token,
  });
  if (responseData?.status === 401) {
    await updateToken();
    return checkWorkTime(params, header);
  } else {
    return new Promise((resolve, reject) => {
      resolve(responseData);
    });
  }
};
// 校验域名是否存在在白名单
export const validateDomain = async (params) => {
  const requestParam = {
    request: encrypt(JSON.stringify(params)),
  };
  const responseData = await get(API_BASE_URL + '/chat/config/validateDomain', requestParam);
  const decryptData = decrypt(responseData);
  return new Promise((resolve, reject) => {
    resolve(JSON.parse(decryptData));
  });
};

// 获取chat配置信息
export const getConfig = async (params) => {
  const requestParam = {
    request: encrypt(JSON.stringify(params)),
  };
  const responseData = await get(API_BASE_URL + '/chat/config/getConfig', requestParam);
  const decryptData = decrypt(responseData);
  return new Promise((resolve, reject) => {
    resolve(JSON.parse(decryptData));
  });
};

/**
 * 请求connect接口，获取令牌信息
 * @param params
 * @returns {Promise<unknown>}
 */
export const requestConnect = (params) => {
  // 请求地址
  let url = params.endpoint;
  //返回数据
  return new Promise(async (resolve, reject) => {
    // 发送请求
    let response = await post(url, params);
    if (response) {
      resolve(response);
    } else {
      reject();
    }
  });
};
export const requestOpenVideo = (params, endpoint) => {
  // 请求地址
  let url = endpoint;
  //返回数据
  return new Promise(async (resolve, reject) => {
    // 发送请求
    let response = await post(url, params);
    if (response) {
      resolve(response);
    } else {
      reject();
    }
  });
};
export const getAllQuestions = async (params) => {
  const requestParam = {
    data: encrypt(JSON.stringify(params)),
  };
  const responseData = await get(API_BASE_URL + '/chat/config/getAllQuestions?channelId=' + params.channelId);
  return new Promise((resolve, reject) => {
    resolve(responseData);
  });
};
// =============================知识库相关接口 start=======================================================

/**
 * 发送知识库消息
 * @param params {{companyId: *, chatMember: string, desAddress: (*|string), isCheckAI: string, questions: *, chatUserName: *, language: string, sessionId: string, qid: string, channelId: *, memberId: (*|string)}}
 */
export const getKnowledgeReply = async (params) => {
  const requestParam = {
    data: encrypt(JSON.stringify(params)),
  };
  const responseData = await post(API_BASE_URL + '/chat/config/forward/knowledge', requestParam);
  const decryptData = decrypt(responseData);
  return new Promise(async (resolve, reject) => {
    resolve(JSON.parse(JSON.parse(decryptData)));
  });
};

// =============================知识库相关接口 end=======================================================

// 上传附件
export const uploadFile = (params) => {
  return new Promise(async (resolve, reject) => {
    // 发送请求
    let localhostUrl = 'http://localhost:8290';
    let response = await post(localhostUrl + '/chat/config/upload', params, {
      'Content-Type': 'multipart/form-data',
    });
    if (response) {
      resolve(response);
    } else {
      reject();
    }
  });
};

export const sendLog = (logName, params) => {
  const logDetail = {
    logName: logName,
    detail: params,
  };
  const requestParam = {
    request: encrypt(JSON.stringify(logDetail)),
  };
  get(API_BASE_URL + '/chat/log/print', requestParam);
};

/**
 * 满意度评分
 */
export const chatCsatScore = async (params) => {
  const requestParam = {
    request: encrypt(JSON.stringify(params)),
  };
  const responseData = await get(API_BASE_URL + '/chat/csat/score', requestParam);
  const decryptData = decrypt(responseData);
  return new Promise(async (resolve, reject) => {
    resolve(JSON.parse(decryptData));
  });
};

/**
 * 获取S3上传的文件地址，使用它作为上传的api地址
 * @param fileName 文件名称
 * @returns url
 */
export const getUploadPreSignedUrl = async (fileName, fileType, companyId, date) => {
  const requestParam = {
    request: encrypt(
      JSON.stringify({
        fileName: fileName,
        fileType: fileType,
        companyId: companyId,
        date: date,
      })
    ),
  };

  const responseData = await get(API_BASE_URL + '/chat/config/getUploadPreSignedUrl', requestParam);
  const decryptData = decrypt(responseData);
  return new Promise((resolve, reject) => {
    resolve(JSON.parse(decryptData));
  });
};

/**
 * 获取S3上传的文件地址
 * @param fileName 文件名称
 * @returns url
 */
export const getDownloadPreSignedUrl = async (fileName, fileType, companyId, date) => {
  const requestParam = {
    request: encrypt(
      JSON.stringify({
        fileName: fileName,
        fileType: fileType,
        companyId: companyId,
        date: date,
      })
    ),
  };
  // let localhostUrl = 'http://localhost:8290';

  const responseData = await get(API_BASE_URL + '/chat/config/getDownloadPreSignedUrl', requestParam);
  const decryptData = decrypt(responseData);
  return new Promise((resolve, reject) => {
    resolve(JSON.parse(decryptData));
  });
};

export const getKnowledgeReplyV2 = async (params) => {
  // let url = 'http://192.168.110.11:5003/chat';
  let url = 'http://10.100.100.69:5003/chat';

  const responseData = await post(url, params);

  return new Promise((resolve, reject) => {
    resolve(responseData);
  });
};

export const getKnowledgeReplyStream = (params) => {
  let param = encrypt(JSON.stringify(params));
  let encodeData = encodeURIComponent(param);
  // let url = "http://localhost:8290/chat/config/forward/knowledge/stream?data=" + encodeData;
  let url = API_BASE_URL + '/chat/config/forward/knowledge/stream?data=' + encodeData;
  return url;
};

// 消息数量
export const getMessageCount = async (params) => {
  const API_BASE_URL = 'https://' + process.env.API_HOST + '/im';
  let url =
    API_BASE_URL +
    '/message/customer/unread/count?companyId=' +
    params.companyId +
    '&sessionId=' +
    params.sessionId +
    '&role=' +
    params.role;
  const responseData = await get(url);
  return new Promise((resolve, reject) => {
    resolve(responseData);
  });
};

export const getKnowledgeReplyStream2 = () => {
  let url = API_BASE_URL + '/api/openapi/aiagent/run';
  // let url = 'http://192.168.110.42:5003/rag/chat_public';
  return url;
};

export const getKnowledgeReplyStreamV2 = (params) => {
  // let url = "http://localhost:8290/chat/config/forward/knowledge/stream?data=" + encodeData;
  // let url = 'http://localhost:8290/chat/test1/getRobotStream/v1?content=' + params.questions;
  let url = 'http://localhost:8290/chat/test2/getRobotStream/v1?content=' + params.questions;
  return url;
};

export const getGuideQuestion = async (params) => {
  const requestParam = {
    request: encrypt(JSON.stringify(params)),
  };
  const responseData = await get(API_BASE_URL + '/chat/config/getGuideQuestion', requestParam);
  const decryptData = decrypt(responseData);
  return new Promise((resolve, reject) => {
    resolve(JSON.parse(decryptData));
  });
};

export const upvoteOrDownvote = async (params) => {
  const requestParam = {
    request: encrypt(JSON.stringify(params)),
  };
  const responseData = await get(API_BASE_URL + '/chat/message/upvoteOrDownvote', requestParam);
  const decryptData = decrypt(responseData);
  return new Promise((resolve, reject) => {
    resolve(JSON.parse(decryptData));
  });
};
//获取单条会话历史记录详情
export const getHistorySessionDetail = async (params) => {
  const response = await axios.post(
    API_BASE_URL + '/api/crm/call/workRecord/noLoginQueryWorkOrderListByWorkId',
    params
  );
  if (response?.data?.code === 200) {
    return response.data;
  } else {
    throw new Error('Failed to fetch history session detail');
  }
};
